module.exports = __webpack_public_path__ + "img/arrow.19c229cf.svg";